import React, { useEffect, useState } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import { api } from "../lib/api";
import { ProductCard } from "../components/ProductCard";
import { useCart } from "../context/CartContext";
import { toast } from "sonner";

export default function Catalogo() {
  const { categorySlug } = useParams();
  const [params, setParams] = useSearchParams();
  const q = params.get("q") || "";
  const [products, setProducts] = useState([]);
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const { addItem } = useCart();

  useEffect(() => {
    api.get("/categories").then(({ data }) => setCategories(data));
  }, []);

  useEffect(() => {
    setLoading(true);
    const params = new URLSearchParams();
    if (categorySlug) params.set("category", categorySlug);
    if (q) params.set("q", q);
    api.get(`/products?${params.toString()}`).then(({ data }) => setProducts(data)).finally(() => setLoading(false));
  }, [categorySlug, q]);

  const cat = categories.find((c) => c.slug === categorySlug);

  return (
    <div className="mx-auto max-w-7xl px-6 lg:px-12 py-12" data-testid="catalogo-page">
      <header className="mb-12">
        <p className="text-xs uppercase tracking-[0.3em] text-[#A94438]">Catálogo</p>
        <h1 className="font-serif text-5xl sm:text-6xl tracking-tighter mt-2">
          {cat ? cat.name : q ? `Resultados: "${q}"` : "Toda la tienda"}
        </h1>
        {cat?.description && <p className="mt-4 max-w-2xl text-[#5B605E]">{cat.description}</p>}
      </header>

      <div className="flex flex-wrap gap-3 mb-10" data-testid="filter-bar">
        <button onClick={() => { window.location.href = "/catalogo"; }} className={`px-4 py-2 text-xs uppercase tracking-wider border ${!categorySlug ? "bg-[#2C302E] text-[#F9F6F0]" : "border-[#2C302E]"}`}>Todo</button>
        {categories.map((c) => (
          <a key={c.id} href={`/catalogo/${c.slug}`} className={`px-4 py-2 text-xs uppercase tracking-wider border ${categorySlug === c.slug ? "bg-[#2C302E] text-[#F9F6F0]" : "border-[#2C302E]"}`} data-testid={`filter-${c.slug}`}>{c.name}</a>
        ))}
        <input
          type="text"
          defaultValue={q}
          onKeyDown={(e) => { if (e.key === "Enter") setParams({ q: e.target.value }); }}
          placeholder="Buscar…"
          className="ml-auto px-4 py-2 text-sm bg-transparent border border-[#2C302E] focus:outline-none"
          data-testid="search-input"
        />
      </div>

      {loading ? (
        <p className="text-[#5B605E]">Cargando…</p>
      ) : products.length === 0 ? (
        <p className="text-[#5B605E]">Sin productos por aquí.</p>
      ) : (
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-x-6 gap-y-12">
          {products.map((p) => (
            <ProductCard key={p.id} product={p} onAdd={(prod) => { addItem(prod); toast.success(`${prod.name} añadido`); }} />
          ))}
        </div>
      )}
    </div>
  );
}
